import { md5 } from 'js-md5';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';

/**
 * calculate MD5 hash for the uploaded file
 * @param file - file to be uploaded
 * @returns md5
 */
export const calculateMD5ForFile = async (file: File, errorMessage: string): Promise<string> => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = (event) => {
			try {
				const arrayBuffer = event.target?.result as ArrayBuffer;
				// Use js-md5 to calculate the MD5 hash of the file content
				const hash = md5(arrayBuffer);
				resolve(hash);
			} catch {
				reject('Error calculating MD5 hash');
			}
		};

		reader.onerror = () => {
			showToastV2({
				title: errorMessage,
				state: 'error',
			});
			reject('Error reading the file');
		};

		// Read the file as an ArrayBuffer
		reader.readAsArrayBuffer(file);
	});
};
